import dayjs from "dayjs"
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const formatDateDuration = (duration: number) => {

    if (duration < 60) {
        return dayjs.duration(duration, 'minutes').format("m[min]")
    } else if (duration === 60) {
        return dayjs.duration(duration, 'minutes').format("H[hr]")
    } else {
        return dayjs.duration(duration, 'minutes').format("H[hr] m[min]")
    }
}